module.exports = __webpack_public_path__ + "img/clive-pro.76fc61ce.jpg";